<template>
	<b-form>
		<div v-if="formData.fields" class="row">
			<base-field
				v-for="field in orderedFields"
				:key="field.field_id"
				ref="baseFields"
				:field="field"
				:person-number="1"
				:form-data="formData"
				@blur="onBlur"
			/>
		</div>
	</b-form>
</template>

<script>
import { mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';

import {
	CHECKOUT_STORE_NAMESPACE,
	ACTION_SAVE_ORDER,
	ACTION_SAVE_FORM_DATA_BACKEND,
} from '~/store/checkout';

import checkoutForm from '~/mixins/checkoutForm';
import checkoutFormStep from '~/mixins/checkoutFormStep';

import BaseField from '~/components/checkout/CheckoutBaseField.vue';

export default {
	name: 'Step3PayByInvoice',
	components: {
		BaseField,
	},
	mixins: [validationMixin, checkoutFormStep, checkoutForm],
	props: [
		'formData',
		'fields',
	],
	data() {
		return {
			isInvoiceVisible: false,
			collapseCardId: 'collapse-card_1',
			paymentProvider: null,
			paymentMethod: null,
			paymentMethodText: 'Выберите способ оплаты',
		};
	},
	computed: {
		...mapGetters({
			getAdditionalPersonsCount: 'checkout/getAdditionalPersonsCount',
			getStep: 'checkout/getStep',
			getScenario: 'checkout/getScenario',
		}),
		count() {
			return Object.keys(this.$store.state.checkout.formsData.fields).length;
		},
		price() {
			return parseFloat(this.product.price);
		},
		orderedFields() {
			const step = this.formData.reverse_step_4 ? 4 : 3;
			const scenario = this.getScenario(this.formData.id);
			return this.fieldsByScenario(step, scenario);
		},
	},
	methods: {
		selectPaymentMethod(paymentMethod) {
			this.paymentMethod = paymentMethod;
		},

		selectPaymentProvider(paymentProvider) {
			this.paymentProvider = paymentProvider;
		},

		setPaymentMethodDropdownText(target) {
			this.paymentMethodText = target.innerHTML;
		},
		doOnlinePayment() {
			this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_ORDER}`, {
				formId: this.formData.id,
			});

			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);

			this.$api.doOnlinePayment({
				paymentProvider: this.paymentProvider,
				paymentMethod: this.paymentMethod,
				formId: this.formData.id,
				uniqueId: this.$store.state.uniqueId.uniqueId,
			}).then((response) => {
				window.location.href = response.payment_url;
			});
		},
	},
};
</script>

<style lang="scss">
@import "~/assets/styles/components/home/prog-registration";
</style>
